import styled from 'styled-components';

import Button from 'components/Buttons/Button';

import { BackgroundTypes } from '.';
import { IconTypes } from './components/Icon';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-top: 50px;
  font-weight: 600;
  overflow: auto;
`;

export const Title = styled.h2`
  margin-top: auto;
  text-align: center;
  padding: 0 55px;
  color: ${({ theme }) => theme.responseScreen.title};
`;
export const SubTitle = styled.span`
  margin-top: 10px;
  text-align: center;
  padding: 0 55px;
  color: ${({ theme }) => theme.responseScreen.title};
`;

export const TextSub = styled.h5`
  margin-top: 30px;
  padding: 0 55px;
  text-align: center;
  color: ${({ theme }) => theme.responseScreen.text};
`;

interface IconProps {
  type?: IconTypes;
}

export const Icon = styled.img.attrs<any, IconProps>((): any => {})`
  width: 50px;
  margin-top: 130px;
  margin-left: ${({ type }) => (type === IconTypes.Airplane ? 'auto' : '0')};
  margin-right: ${({ type }) => (type === IconTypes.Airplane ? 'calc(50% - 100px)' : '0')};

  @media only screen and (max-height: 670px) {
    margin-top: 20px;
  }

  @media ${({ theme }) => theme.device.desktop} {
    margin-top: 30px;
  }
`;

export const TextButton = styled(Button)`
  max-width: 343px;
  height: 56px;
  font-size: 16px;
  margin: 0 16px 32px 16px;
`;

interface StyledProps {
  type?: BackgroundTypes;
}

export const BgImage = styled.div.attrs<any, StyledProps>((): any => {})`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  margin-top: auto;

  @media ${({ theme }) => theme.device.desktop} {
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  }

  ${({
    type,
    theme: {
      responseScreen: { backgroundImage },
    },
  }) => {
    switch (type) {
      case BackgroundTypes.Mountain:
        return `
          background-image: url('/images/trees.svg'), linear-gradient(to bottom, ${backgroundImage}, ${backgroundImage});
          background-position: 0 0, 0 70px;
          background-repeat: repeat-x, no-repeat;
          height: 286px;
        `;
      case BackgroundTypes.Cloud:
        return `
          background-image: url('/images/clouds.svg'), url('/images/trail.svg'), linear-gradient(to bottom, ${backgroundImage}, ${backgroundImage});
          background-position: 0 0, center -20px, 0 70px;
          background-repeat: repeat-x, no-repeat, no-repeat;
          height: 342px;
        `;
      default:
        return `
          background-image: url('/images/success-simple-clouds.svg');
          background-position: top;
          height: 362px;
        `;
    }
  }}
`;
